import { defineChain } from 'viem';

export const lazaiMainnet = defineChain({
    id: 52924,
    name: 'LazAI Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'METIS',
        symbol: 'METIS',
    },
    rpcUrls: {
        default: {
            http: ['https://mainnet.lazai.network'],
            webSocket: ['wss://mainnet.lazai.network'],
        },
        public: {
            http: ['https://mainnet.lazai.network'],
            webSocket: ['wss://mainnet.lazai.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'LazAI Explorer',
            url: 'https://explorer.mainnet.lazai.network',
        },
    },
});
